site.multiselect = {
	init: function(selector) {
		$.localise('ui-multiselect', {language: moya.lang, path: '/_moya/js/jquery/multiselect/js/locale/'});
		$(selector).multiselect({
			sortable: true,
			searchable: true,
		});
	}
};
